module.exports = __webpack_public_path__ + "static/seres-silk-duvet-1-ow-a1d1ad03a74d57989f35eb8a976e4a74.webp";